var $cbaf8b5b61f9e544$exports = {};
$cbaf8b5b61f9e544$exports = {
  "decrease": function decrease(args) {
    return "Upadati ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "Pove\u010Dajte ".concat(args.fieldLabel);
  },
  "numberField": "\u0160tevil\u010Dno polje"
};
export { $cbaf8b5b61f9e544$exports as default };